import { QueryStatus } from '@reduxjs/toolkit/dist/query';
import { AdvancedReportQueryStatus } from '../advanced-reports.types';

export const areSomeRequestsStillPending = (
  advancedReportQueryStatus: AdvancedReportQueryStatus
): boolean =>
  advancedReportQueryStatus.impressions === QueryStatus.pending ||
  advancedReportQueryStatus.clicks === QueryStatus.pending ||
  advancedReportQueryStatus.calls === QueryStatus.pending ||
  advancedReportQueryStatus.webs === QueryStatus.pending ||
  advancedReportQueryStatus.opps === QueryStatus.pending ||
  advancedReportQueryStatus.oppValues === QueryStatus.pending ||
  advancedReportQueryStatus.sales === QueryStatus.pending ||
  advancedReportQueryStatus.revenues === QueryStatus.pending ||
  advancedReportQueryStatus.costs === QueryStatus.pending;
